import Env from '../base/env'
import gsap from 'gsap'
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export default class ItemReveal
{
  constructor(view)
  {
    this.view = view
  }

  animate()
  {
    const coord = this.view.getBoundingClientRect()
    const st = ScrollTrigger.create({
      immediateRender:false,
      start: ()=> coord.left,
      end: ()=>coord.left + coord.width,
      markers: false,
      scrub: Env.scrollTrigger.parallax.scrub,
      onEnter:()=>{
        if(this.view.classList.contains('is-shown') == false) {
          this.view.classList.add('is-shown')
        }
      }
    })
  }
}
